import React from 'react';

interface CustomCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ checked, onChange, className = '' }) => {
  return (
    <div 
      className={`relative w-[16px] h-[16px] cursor-pointer ${className}`}
      onClick={() => onChange(!checked)}
    >
      <div className={`
        w-full h-full rounded-[4px] ${!checked && 'border border-[#DDDDDD]'} bg-[#FFFFFF]
      `}>
        {checked && (
          <svg
            className="w-full h-full text-[#222222] bg-[#42E56F] rounded-[4px]"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 10L8.5 13.5L15 7"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
    </div>
  );
};

export default CustomCheckbox; 